<div class="sign-in-flow" (input)="onFieldInteraction($event)" (pointerdown)="onFieldInteraction($event)">
    <div class="sign-in-flow__blob sign-in-flow__blob--orange" aria-hidden="true"></div>
    <div class="sign-in-flow__blob sign-in-flow__blob--blue" aria-hidden="true"></div>
    <div class="sign-in-flow__blob sign-in-flow__blob--green" aria-hidden="true"></div>

    <div class="sign-in-flow__row">

        <img class="sign-in-flow__logo" src="./assets/images/logos/login-logo.png" alt="COMMITLY" width="134" height="35"/>

        <div class="sign-in-flow__card" *ngIf="!waitOtpToken">
            <form class="sign-in-flow__form" (ngSubmit)="signIn()">
                <button type="submit" hidden tabindex="-1" aria-hidden="true" [disabled]="isSubmitting"></button>
                <p class="sign-in-flow__heading">{{'SignIn.Title' | translate}}</p>

                <div class="sign-in-flow__notice" data-test-id="login-activation-notice" *ngIf="userActivate.activated">
                    {{'SignUp.SignUpActivated' | translate}}
                </div>

                <app-input-line-form
                    [control]="emailCtrl"
                    [submitted]="submitPressed"
                    [type]="'email'"
                    [labelName]="'SignIn.Form.EmailLabel'"
                    [placeholder]="'SignIn.Form.EmailPlaceholder' | translate"
                    [tabindex]="1"
                    [autocomplete]="'username'"
                    id="email"
                    data-test-id="login-email"
                ></app-input-line-form>

                <div class="sign-in-flow__password">
                    <div class="sign-in-flow__password-label-row">
                        <span class="sign-in-flow__password-label">{{'SignIn.Form.PasswordLabel' | translate}}</span>
                        <a class="sign-in-flow__forgot" [uiSref]="restoreEmail">
                            {{'SignIn.Form.ForgotPassword' | translate}}
                        </a>
                    </div>
                    <app-input-password
                        [control]="passwordCtrl"
                        [submitted]="submitPressed"
                        [placeholder]="'SignIn.Form.PasswordPlaceholder' | translate"
                        [invalid]="submitPressed && (validationFailed || !!passwordCtrl.errors)"
                        [tabindex]="2"
                        [autocomplete]="'current-password'"
                        id="password"
                        data-test-id="login-password"
                    ></app-input-password>

                    <div class="sign-in-flow__error-summary" data-test-id="login-error" [hidden]="!(errors.length > 0)">
                        <span class="sign-in-flow__error" *ngFor="let error of errors" [innerHTML]="error | async"></span>
                    </div>
                </div>

                <ui-text-button
                    class="sign-in-flow__submit"
                    [buttonStyle]="buttonStyle.Green"
                    data-test-id="login-submit"
                    (click)="signIn()"
                    [disabled]="isSubmitting"
                >
                    {{'SignIn.Form.SignIn' | translate}}
                    <div class="loader" *ngIf="isSubmitting">
                        <img class="image image-load" src="./assets/images/loader.png" alt="">
                    </div>
                </ui-text-button>
            </form>

            <div class="sign-in-flow__signup">
                <div class="sign-in-flow__divider"></div>
                <span>{{'SignIn.Form.NoAccount' | translate}}</span>
                <a [uiSref]="signUpState" data-test-id="login-page-sign-up-link">
                    {{'SignIn.Form.SignUp' | translate}}
                </a>
            </div>
        </div>

        <div class="sign-in-flow__card" *ngIf="waitOtpToken">
            <form class="sign-in-flow__form" (ngSubmit)="submitToken()">
                <button type="submit" hidden tabindex="-1" aria-hidden="true" [disabled]="isTokenSubmitting"></button>
                <p class="sign-in-flow__heading">{{'2fa.ValidateTitle' | translate}}</p>
                <p class="sign-in-flow__subheading" [innerHTML]="'2fa.TokenDescription' | translate | safeHtml"></p>

                <div class="sign-in-flow__field">
                    <app-input-line-form
                        appAutofocus
                        [control]="tokenCtrl"
                        [submitted]="tokenSubmitPressed"
                        [labelName]="'2fa.TokenLabel'"
                        [placeholder]="'2fa.TokenPlaceholder' | translate"
                        [invalid]="validationTokenFailed"
                        [tabindex]="1"
                        data-test-id="login-otp-token"
                    ></app-input-line-form>

                    <div class="sign-in-flow__error-summary" data-test-id="login-otp-error" [hidden]="!(errors.length > 0)">
                        <span class="sign-in-flow__error" *ngFor="let error of errors" [innerHTML]="error | async"></span>
                    </div>
                </div>

                <div class="sign-in-flow__otp-actions">
                    <ui-text-button
                        class="sign-in-flow__submit"
                        [buttonStyle]="buttonStyle.Green"
                        data-test-id="login-otp-submit"
                        (click)="submitToken()"
                        [disabled]="isTokenSubmitting || (tokenSubmitPressed && tokenCtrl.invalid)"
                    >
                        {{'2fa.ValidateToken' | translate}}
                        <div class="loader" *ngIf="isTokenSubmitting">
                            <img class="image image-load" src="./assets/images/loader.png" alt="">
                        </div>
                    </ui-text-button>
                    <ui-text-button
                        class="sign-in-flow__submit"
                        [buttonStyle]="buttonStyle.Gray"
                        data-test-id="login-otp-cancel"
                        (click)="cancel()"
                        [disabled]="isTokenSubmitting"
                    >
                        {{'2fa.Logout' | translate}}
                    </ui-text-button>
                </div>
            </form>
        </div>

        <a
            class="sign-in-flow__referral"
            [href]="'SignIn.Referral.Url' | translate"
            target="_blank"
            rel="noreferrer"
        >
            <div class="sign-in-flow__referral-info">
                <div class="sign-in-flow__referral-info__badge">{{'SignIn.Referral.Badge' | translate}}</div>
                <p class="sign-in-flow__referral-info__headline" [innerHTML]="'SignIn.Referral.Headline' | translate | safeHtml"></p>
                <p class="sign-in-flow__referral-info__desc" [innerHTML]="'SignIn.Referral.Description' | translate | safeHtml"></p>
            </div>
            <div class="sign-in-flow__referral-earnings">
                <div class="sign-in-flow__referral-earnings__icon">
                   <ui-button
                        class="celloButton"
                        [iconName]="'cello-gift'"
                        [iconColor]="'white'"
                        [bgColor]="'green'"
                    ></ui-button>
                </div>
                <div class="sign-in-flow__referral-earnings__text">
                    <p class="sign-in-flow__referral-earnings__amount">{{'SignIn.Referral.EarningsAmount' | translate}}</p>
                    <p class="sign-in-flow__referral-earnings__caption">{{'SignIn.Referral.EarningsCaption' | translate}}</p>
                </div>
            </div>
        </a>

    </div>
</div>
